<template>
	<page-container :page="page">
		<heading-image
			v-if="page.headingImage"
			:heading-image="{
				image: page.headingImage,
				imageWebp: page.headingImageWebp,
				imagePortrait: page.headingImagePortrait,
				imagePortraitWebp: page.headingImagePortraitWebp,
			}"
		/>
		<breadcrumbs
			:breadcrumbs="page.breadcrumbs"
			:class="page.headingImage ? '' : 'no-slider'"
			:home="defaults[locale].website.hotelName"
		/>

		<main-content :title="page.title || page.header" :content="page.content" :bookingid="page.bookingID" />

		<section class="highlights">
			<highlights-map :items="highlights" />
		</section>

		<section v-if="allHighlights.length" class="highlight-blocks main-content">
			<div v-for="(highlight, index) in allHighlights" :key="highlight.ID" class="row">
				<div class="columns column6" :class="index % 2 === 0 ? 'right' : 'left'">
					<picture>
						<source v-if="highlight.imageWebp" :srcset="highlight.imageWebp" type="image/webp" />
						<source :srcset="highlight.image" />
						<img :src="highlight.image" :alt="highlight.imageAlt" loading="lazy" />
					</picture>
				</div>
				<div class="columns column6" :class="index % 2 === 0 ? 'left' : 'right'">
					<h2>{{ highlight.header }}</h2>
					<div v-parse-links v-html="highlight.description" />
					<a :href="highlight.url" target="_blank" rel="noopener noreferrer" class="button button-no-fill">
						{{ $t('moreInformation') }}
					</a>
				</div>
			</div>
		</section>
	</page-container>
</template>

<script setup>
const { page, fetchPage } = usePage();
const { defaults, fetchDefaults } = useDefaults();
const { locale } = useI18n();
const allHighlights = ref([]);

await fetchPage();
await fetchDefaults();

const { data: highlights } = await useWebsiteFetch('highlights', {
	query: { language: locale.value },
	key: `${locale.value}/highlights`,
});

watchEffect(() => {
	allHighlights.value = highlights.value
		.map((category) => category.items)
		.flat()
		.filter((item) => !!item.description);
});
</script>

<style lang="scss" scoped>
#gmap {
	height: 500px;
}

.highlights {
	width: 100%;

	.row {
		max-width: none;
		width: 100%;
		background: #f5f5f5;
	}

	.column9 {
		padding: 0;
	}
}

.highlights-navigation {
	padding: 50px;

	a {
		cursor: pointer;
	}

	.button {
		width: 100%;
		border: 1px solid #000;

		&:hover,
		&.active {
			background: #eb5757;
			border-color: #eb5757;
			color: #fff;
		}
	}

	.button,
	li {
		font-size: $button-font-size;
	}
}

.highlight-item {
	width: 100%;
	color: #000;
	border: none;
	cursor: pointer;
	transition: all 0.4s linear;
	text-align: left;

	&.active,
	&:hover {
		color: #eb5757;
	}
}

.highlight-content {
	ul {
		margin: 0;
		padding-bottom: 20px;
	}
}

.highlight-blocks {
	.row {
		padding: 25px 0;
	}

	.columns {
		padding: 20px;
	}

	span {
		margin: 0 10px 20px 0;
		display: inline-block;
	}
}

@media (max-width: 1500px) {
	.highlights-navigation {
		padding: 50px 25px;
	}
}

@media (max-width: 600px) {
	.highlights .row {
		display: flex;
		flex-direction: column-reverse;
	}
}
</style>
